module.exports = __webpack_public_path__ + "img/TimesCircleSolid.0a8df422.png";